module.exports = __webpack_public_path__ + "img/h5_logo.3d8089b6.png";